import React from "react";

/** hooks */
import { useAuth } from "@hooks/useAuth";

import useTheme from "@styles/useTheme";
import useTranslation from "@languages/useTranslation";

import SidebarDrawerMenu from "@atoms/SidebarDrawerMenu";
import { useSidebarMenu } from "@hooks/menuItensContext";

const SidebarDrawerMenus: React.FC = () => {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const { user } = useAuth();
  const { menuItems } = useSidebarMenu();

  return (
    <>
      { menuItems.map(({ id, title, icon, link, onlyAdmin, hidden }) => {

        if (onlyAdmin && !user.admin) return null;
        if (!user.admin && hidden) return null;

        return (
          <SidebarDrawerMenu
            key={`${id}_${title}`}
            id={id}
            title={t(title)}
            icon={icon}
            link={link}
            secondaryColor={theme.colors.secondary}
            identifierColor={theme.colors.tertiary}
            type="primary"
          />
        );
      })}
    </>
  );
};

export default React.memo(SidebarDrawerMenus);
